import React from "react";
import "./Footer.scss";

const Footer = () => {
  return (
    <div className="footer-div">
      <div className="contact-info">
        <p className="footer">
          W razie wątpliwości pisz na adres:{"  "}
          <strong>kontakt at netadminpro.pl</strong>
        </p>
      </div>
      <br />
      <div className="links">
        <p className="footer">
          <a href="https://netadminpro.pl/polityka-prywatnosci">
            Polityka prywatności
          </a>{" "}
          <a href="https://netadminpro.pl/regulaminy/">Regulaminy</a>
        </p>
      </div>
    </div>
  );
};

export default Footer;
